import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";


import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tipo_id: null,
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }
    setSelects(data) {
        this.setState({
            tipo_id: data.tipo_id,
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.plan.subtipos.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Subtipo de Transferencia"}
                buttonTitle={"Subtipo de Transferencia"}
                buttonIcon={"fa fa-search fa-lg"}
                
                saveButton={false}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}>
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="nombre" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Tipo</Label>
                    </Col>
                    <Col className="col-10">
                        <ParadigmaAsyncSeeker disabled={true} value={this.state.tipo_id} onChange={(value) => this.setState({ tipo_id: value.pk })} fieldName={"tipo_id"} url={api.proyectos.config.plan.tipos.select} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Plan_SubTipos/Detail.js